<header-template></header-template>

<main id="app-content">
	<p-toast></p-toast>
	<router-outlet></router-outlet>
</main>

<footer-template></footer-template>

<app-loader *ngIf="globals.userLoaded()"></app-loader>
<!-- <install-prompt></install-prompt> -->
